import { ContractInterface } from 'contract/type';
import { makeAutoObservable } from 'mobx';
import { LibraryInterface } from '../types/contentType';

type LibraryCache = {
  [id: number]: {
    data: LibraryInterface;
    contract?: ContractInterface;
    timestamp: number;
  };
};

class LibraryStore {
  private readonly MAX_CACHE_SIZE = 5;
  private cache: LibraryCache = {};

  constructor() {
    makeAutoObservable(this);
  }

  public getLibrary = (id: number): LibraryInterface | null => {
    return this.cache[id]?.data || null;
  };

  public getContract = (id: number): ContractInterface | null => {
    return this.cache[id]?.contract || null;
  };

  public setLibrary = (id: number, data: LibraryInterface, contract?: ContractInterface): void => {
    if (Object.keys(this.cache).length >= this.MAX_CACHE_SIZE && !this.cache[id]) {
      const oldestId = Object.entries(this.cache).reduce(
        (oldest: number, [currentId, value]) => {
          return value.timestamp < this.cache[oldest].timestamp ? Number(currentId) : oldest;
        },
        Number(Object.keys(this.cache)[0])
      );

      delete this.cache[Number(oldestId)];
    }

    this.cache[id] = {
      data,
      contract: contract || undefined,
      timestamp: Date.now(),
    };
  };

  public clearCache = (): void => {
    this.cache = {};
  };

  public removeLibrary = (id: number): void => {
    delete this.cache[id];
  };
}

export const libraryStore = new LibraryStore();
